var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INLINE_STYLES } from '../helper';
var IconS24SolarPanel48 = function (_a) {
    var inline = _a.inline, title = _a.title, rest = __rest(_a, ["inline", "title"]);
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 32 32", fill: "currentColor" }, rest, { style: __assign(__assign({}, (inline && INLINE_STYLES)), rest.style) }),
        React.createElement("path", { d: "M23.9999 20C26.7609 20 28.9999 17.761 28.9999 15C28.9999 12.239 26.7609 10 23.9999 10C21.2389 10 18.9999 12.239 18.9999 15C18.9999 17.761 21.2389 20 23.9999 20ZM23.9999 12C25.6569 12 26.9999 13.343 26.9999 15C26.9999 16.657 25.6569 18 23.9999 18C22.3429 18 20.9999 16.657 20.9999 15C20.9999 13.343 22.3429 12 23.9999 12Z", fill: "#333333" }),
        React.createElement("path", { d: "M24.9999 4H22.9999V8H24.9999V4Z", fill: "#333333" }),
        React.createElement("path", { d: "M34.9999 14H30.9999V16H34.9999V14Z", fill: "#333333" }),
        React.createElement("path", { d: "M16.9999 14H12.9999V16H16.9999V14Z", fill: "#333333" }),
        React.createElement("path", { d: "M30.8869 6.70794L28.2996 9.2952L29.7123 10.708L32.2997 8.12077L30.8869 6.70794Z", fill: "#333333" }),
        React.createElement("path", { d: "M18.3042 19.2868L15.7162 21.8748L17.1305 23.289L19.7184 20.701L18.3042 19.2868Z", fill: "#333333" }),
        React.createElement("path", { d: "M17.1293 6.70859L15.7138 8.11865L18.2961 10.711L19.7116 9.3009L17.1293 6.70859Z", fill: "#333333" }),
        React.createElement("path", { d: "M29.7127 19.2941L28.2987 20.7086L30.8872 23.2961L32.3012 21.8817L29.7127 19.2941Z", fill: "#333333" }),
        React.createElement("path", { d: "M37.6929 25H24.9999V22H22.9999V25H10.3069L3.55688 43H44.4429L37.6929 25ZM24.9999 34H32.1139L33.9949 41H24.9999V34ZM22.9999 41H14.3039L16.1849 34H22.9989L22.9999 41ZM24.9999 32V27H30.2329L31.5769 32H24.9999ZM34.1859 34H38.9319L41.5569 41H36.0669L34.1859 34ZM38.1819 32H33.6479L32.3039 27H36.3059L38.1819 32ZM22.9999 32H16.7229L18.0669 27H22.9999V32ZM11.6929 27H15.9949L14.6509 32H9.81788L11.6929 27ZM9.06788 34H14.1139L12.2329 41H6.44288L9.06788 34Z", fill: "#333333" })));
};
export default IconS24SolarPanel48;
//# sourceMappingURL=IconS24SolarPanel48.js.map